module.exports = "#search {\n  display: none; }\n\n#search.toggled {\n  display: block; }\n"